import React from 'react';
import LocalizedStrings from 'react-localization';
import agent from '../../agent';
import ErrorMessage from '../Utils/ErrorMessage'
import { connect } from 'react-redux';
import {
  UPDATE_FIELD_AUTH,
  LOGIN,
  LOGIN_PAGE_UNLOADED
} from '../../constants/actionTypes';
import './Login.css';

const mapStateToProps = state => ({ ...state.auth });

const mapDispatchToProps = dispatch => ({
  onChangeEmail: value =>
    dispatch({ type: UPDATE_FIELD_AUTH, key: 'email', value }),
  onChangePassword: value =>
    dispatch({ type: UPDATE_FIELD_AUTH, key: 'password', value }),
  onSubmit: (email, password) =>
    dispatch({ type: LOGIN, payload: agent.Auth.login(email, password) }),
  onUnload: () =>
    dispatch({ type: LOGIN_PAGE_UNLOADED, token: window.localStorage.getItem('jwt') })
});

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.changeEmail = ev => this.props.onChangeEmail(ev.target.value);
    this.changePassword = ev => this.props.onChangePassword(ev.target.value);
    this.submitForm = (email, password) => ev => {
      ev.preventDefault();
      this.props.onSubmit(email, password);
    };

    this.strings = new LocalizedStrings({
     en:{
       username: 'Username',
       password: 'Password',
       signIn: 'Sign In'
     },
     de: {
       username: 'Benutzername',
       password: 'Password',
       signIn: 'Einloggen'
     }
    });

    if(props.language) {
      this.strings.setLanguage(props.language);
    }
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {
    const email = this.props.email;
    const password = this.props.password;
    const loginFailed = this.props.loginFailed;
    const errorMessage = this.props.errorMessage;

    return (
      <div className="login-wrapper">
          <div className="row justify-content-center login-form-wrapper">
            <div className="col-md-6 col-xs-12 title_text">
              <img className="logo_image_login" src="img/view_logo.png" srcSet="img/view_logo.png 1x, img/view_logo@2x.png 2x" alt="logo" />
              <br/>
              <ErrorMessage showErrorMessage={loginFailed} errorMessage={errorMessage}/>
              <form className="sign_in_form" onSubmit={this.submitForm(email, password)}>
                <fieldset>

                  <fieldset className="form-group login-email-group">
                    <input
                      type="text"
                      placeholder={this.strings.username}
                      value={email}
                      onChange={this.changeEmail} />
                  </fieldset>

                  <fieldset className="form-group login-password-group">
                    <input
                      type="password"
                      placeholder={this.strings.password}
                      value={password}
                      onChange={this.changePassword} />
                  </fieldset>

                  <button
                    className="btn btn-lg signin_btn float-right"
                    type="submit"
                    disabled={this.props.inProgress}>
                    { this.strings.signIn }
                  </button>

                </fieldset>
              </form>
            </div>

          </div>
          <div className="row justify-content-center login-logo-wrapper">
            <div className="col-5">
              <img alt="3EN Logo" src="img/3en-logo-white-web.png" srcSet="img/3en-logo-white-web.png 1x, img/3en-logo-white-web@2x.png 2x" className="img-fluid mx-auto d-block footer_logo"/>
            </div>
          </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js